import React, { useState } from 'react';
import { CLIENT_LOGOS } from '../data/clientLogos';

const MarqueeLogo = ({ company, variant }) => {
  const [imageError, setImageError] = useState(false);
  const isOnDark = variant === 'on-dark';

  const wrapperClass = isOnDark
    ? 'w-32 h-16 md:w-36 md:h-20 flex items-center justify-center'
    : 'w-32 h-24 flex items-center justify-center bg-card/50 border border-border/30 rounded-lg p-4 hover:border-accent/50 transition-all duration-300 hover:shadow-md';

  const imageClass = isOnDark
    ? 'max-h-10 md:max-h-12 max-w-[120px] object-contain opacity-70'
    : 'max-h-full max-w-full object-contain';

  const fallbackClass = isOnDark
    ? 'text-[10px] font-medium text-white/50 text-center leading-tight px-2'
    : 'text-xs font-medium text-muted-foreground text-center leading-tight px-2';

  return (
    <div className={wrapperClass} title={company.name}>
      {company.logo && !imageError ? (
        <img
          src={company.logo}
          alt={company.name}
          className={imageClass}
          onError={() => setImageError(true)}
        />
      ) : (
        <span className={fallbackClass}>{company.name}</span>
      )}
    </div>
  );
};

const ClientLogosMarquee = ({ variant = 'default', className = '' }) => {
  const items = [...CLIENT_LOGOS, ...CLIENT_LOGOS];

  return (
    <div className={`overflow-hidden relative w-full ${className}`}>
      <div className="flex animate-scroll-left w-max">
        {items.map((company, idx) => (
          <div key={`${company.name}-${idx}`} className="flex-shrink-0 mx-4 md:mx-6">
            <MarqueeLogo company={company} variant={variant} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientLogosMarquee;
